import { Component, OnInit, TemplateRef } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { UtilityService } from '../../core/services/utility.service';
import { PublishResetService } from '../../core/services/publish-reset.service';
import { EventVersion } from '../../core/models/event-version';


@Component({
  selector: 'app-publish',
  templateUrl: './publish.component.html',
  styleUrls: ['./publish.component.css'],
  providers: [PublishResetService]
})
export class PublishComponent implements OnInit {
  eventId: string = '';
  mandatoryUpdate: boolean = false;
  prop: string = '';
  isError: boolean = false;
  message: string = '';
  errorMessage: string = '';
  currentCV: number = 0;
  eventWebPath: string = '';
  eventAppPath: string = '';
  desc: string = null;
  descClass = 'form-control';
  eventVersion = new EventVersion();
  propup1: boolean = false;
  propup: boolean = false;
  modalRef: BsModalRef;
  lastPublishedAt: string = null;

  PUBLISH_LABEL1 = Constants.PUBLISH_LABEL1;
  MODAL_LABEL1 = Constants.MODAL_LABEL1;

  constructor(
    private confirmationService: ConfirmationService, private publishResetService: PublishResetService, private extraService: ExtraService, private route: ActivatedRoute, 
    private router: Router,
    private utilityService: UtilityService, 
    private modalService: BsModalService,
  ) { }


  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {
      let id = params['eventId'];
      if (id) {
        this.eventId = id;
        this.setEventVersionData(id);
        this.setPublishedAt(id);
        this.extraService.setCurrentEventId(id);
      }
    });
  }

  setPublishedAt(id: string) {
    this.publishResetService.getLastPublishedAt(id).subscribe(val => {
      if (val) {
        let datePipe = new DatePipe("en-US");
        this.lastPublishedAt = datePipe.transform(val, Constants.PUBLISH_AT_DATE_FORMAT);
      }
    });
  }

  setEventVersionData(id) {
    this.currentCV = 0;
    this.publishResetService.getEventVersionData(id).subscribe(event => {
      if (event) {
        //console.log(event)
        this.eventVersion = event;
        this.currentCV = event.cv;
      }
    });
  }

  submit() {
    this.modalRef.hide();
    this.propup1 = false;
    this.add();
  }

  publish() {
    this.add();
  }

  add() {
    this.isError = false;
    this.message = null;
    this.errorMessage = null;
    this.clearClass();
    if (this.validate()) {
      if (this.eventId) {
        this.publishResetService.getEventWebObject(this.eventId).then((snapshot) => {
          if (snapshot) {
            this.publishResetService.copyEventWebToEventApp(Object.assign({}, snapshot.val()), this.eventId).then(res => {
              this.message = 'Published Successfully';
            }).catch(error => {
              this.errorMessage = error.message;
              this.setEventVersionData(this.eventId);
              if (!this.mandatoryUpdate) {
                this.eventVersion.cv = --this.currentCV;
                this.publishResetService.updateVersion(this.eventId, this.eventVersion, this.desc);
              } else {
                this.desc = null;
                this.eventVersion.cv = --this.currentCV;
                this.eventVersion.lmv = this.eventVersion.cv;
                this.publishResetService.updateVersion(this.eventId, this.eventVersion, this.desc);
              }
            });
          }
        });
        setTimeout(function () {
          this.message = null;
          this.desc = null;
        }.bind(this), 8000);
      }
    } else {
      this.isError = true;
    }
  }

  validate() {
    let valid = true;
    if (!this.mandatoryUpdate) {
      // if (this.eventVersion.cv == 0) {
      //   this.eventVersion.cv = ++this.currentCV;
      //   this.publishResetService.updateVersion(this.eventId, this.eventVersion, this.desc);
      // } else {
        this.eventVersion.cv = ++this.currentCV;
        this.publishResetService.updateVersion(this.eventId, this.eventVersion, this.desc);
      // }
      return valid = true;
    } else if (this.mandatoryUpdate && !this.desc) {
      this.isError = true;
      this.errorMessage = 'Please give some details about mandatory update';
      this.descClass = "form-control fieldWithErrors";
      return valid = false;
    } else if (this.mandatoryUpdate && this.desc) {
      this.setVersionData();
      return valid = true;
    }
    return valid;
  }

  setVersionData() {
    // if (this.eventVersion.cv == 0) {
    //   this.eventVersion.cv = ++this.currentCV;
    //   this.eventVersion.lmv = this.eventVersion.cv;
    //   console.log(this.eventVersion, this.currentCV)
    //   this.publishResetService.updateVersion(this.eventId, this.eventVersion, this.desc);
    // } else {
      this.eventVersion.cv = ++this.currentCV;
      this.eventVersion.lmv = this.eventVersion.cv;
      console.log(this.eventVersion, this.currentCV)
      this.publishResetService.updateVersion(this.eventId, this.eventVersion, this.desc);
    // }
  }

  clearClass() {
    this.descClass = 'form-control';
  }

  openModal(template: TemplateRef<any>) {
    this.isError = false;
    this.message = null;
    this.errorMessage = null;
    if(this.checkValid()) {
      this.modalRef = this.modalService.show(template);
    } else {
      this.isError = true;
    }
  }

  checkValid() {
    this.clearClass();
    let valid = true;
    if (this.mandatoryUpdate && !this.desc) {
      this.isError = true;
      this.errorMessage = 'Please give some details about mandatory update';
      this.descClass = "form-control fieldWithErrors";
      return valid = false;
    }
    return valid;
  }

}



// WEBPACK FOOTER //
// /app/src/app/event/publish/publish.component.ts